import React, {useState, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

export function OfficialPromptsSection({promptText}) {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopy = useCallback(() => {
        if (!promptText) return;
        navigator.clipboard.writeText(promptText).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    }, [promptText]);

    if (!promptText) return null;

    return (
        <div className="dashbo-mcp-section">
            <div className="prompt-collapsible">
                <button className="prompt-collapsible-toggle" onClick={() => setExpanded(!expanded)}>
                    <FaIcon iconName={expanded ? 'chevron-up' : 'chevron-down'}/>
                    {t('dashbo_mcp.prompts.title')}
                </button>
                {expanded && (
                    <div className="prompt-collapsible-body">
                        <p className="section-description">{t('dashbo_mcp.prompts.description')}</p>
                        <pre className="prompt-text">{promptText}</pre>
                        <div className="prompt-actions">
                            <button className="btn -alt -negative" onClick={handleCopy}>
                                {copied ? t('dashbo_mcp.prompts.copied') : t('dashbo_mcp.prompts.copy')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
